import { render, staticRenderFns } from "./right-customer-detail.vue?vue&type=template&id=12b355e6&scoped=true&"
import script from "./right-customer-detail.vue?vue&type=script&lang=js&"
export * from "./right-customer-detail.vue?vue&type=script&lang=js&"
import style0 from "./right-customer-detail.vue?vue&type=style&index=0&id=12b355e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b355e6",
  null
  
)

export default component.exports